export const USER_INFO = 'USER_INFO';
export const USER_PROGRESS = 'USER_PROGRESS';